import {Filter, type FilterProps, type SuppliedFilterProvider} from '@github-ui/filter'

import {getCustomPropertiesProvider, type PropertyDefinition} from './providers/custom-properties'
import {getAllDateProviders} from './providers/date'
import {LanguageStaticFilterProvider} from './providers/languages'
import {getAllNumberProviders} from './providers/number'
import {getAllStaticProviders, type ReposFilterAdditionalOptions} from './providers/static'

export type {PropertyDefinition}

export interface ReposFilterProps extends Omit<FilterProps, 'providers' | 'sx'> {
  definitions?: PropertyDefinition[]
  orgs?: string[]
  options?: ReposFilterAdditionalOptions
}

export function ReposFilter({definitions, orgs, options, ...props}: ReposFilterProps) {
  const actualProviders: SuppliedFilterProvider[] = getDefaultReposProviders(definitions, orgs, options)

  return <Filter {...props} providers={actualProviders} />
}

export function getDefaultReposProviders(
  definitions?: PropertyDefinition[],
  orgs?: string[],
  options?: ReposFilterAdditionalOptions,
): SuppliedFilterProvider[] {
  const providers: SuppliedFilterProvider[] = [
    ...getAllStaticProviders(orgs, options),
    ...getAllNumberProviders(),
    ...getAllDateProviders(),
  ]

  if (definitions && definitions.length > 0) {
    providers.push(getCustomPropertiesProvider(definitions))
  }

  return [...providers, new LanguageStaticFilterProvider()]
}
